module.exports = __webpack_public_path__ + "media/public/img/go-city-logo-0b36ce9d9e8b9499550ff28e92033c5c.svg";